// Control IDs for the Corporate page (sai's corporate IDs, mapped to ours by
// toTrapezium: corporate.* -> product.corporate.*). Its part rows and Next come
// from sai/ids.js.
import { toTrapezium as t } from './sai/trapezium';

export const IDS = {
  rankBy: (k) => t(`corporate.rank-${k}`), // departments | locations (part 3, Where risk sits; redrawn view only)
  view: (k) => t(`corporate.view-${k}`), // real (the dashboard's own screenshots, default) | drawn (the redrawn sample)
  shot: (k) => t(`corporate.shot-${k}`), // a part's second still: overview | groups (part 1), tests | curve (part 2)
  showcaseSound: t('corporate.showcase-sound'), // the showreel above the dashboard: sound on / off
  showcasePlay: t('corporate.showcase-play'), // play / pause for that video (always shown)
  tryLive: t('corporate.try-live'), // Try now: opens the live demo dashboard in a new tab (external site)
  watchWalkthrough: t('corporate.watch-walkthrough'), // opens the full-walkthrough dialog
  closeWalkthrough: t('corporate.close-walkthrough'), // closes that dialog
  maximizeWalkthrough: t('corporate.maximize-walkthrough'), // full screen for the walkthrough video in that dialog
};
